import React from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faSearch } from "@fortawesome/free-solid-svg-icons";

export default function CoachCombineResultsSection({
  loading,
  dropdownOpen,
  setDropdownOpen,
  selectedCombine,
  dropdownSearch,
  setDropdownSearch,
  filteredCombines,
  onCombineChange,
}) {
  return (
    <>
      <h2 className="text-xl mb-3 uppercase">Combine Results</h2>
      <div className="w-full">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <div className="relative w-full">
            <button
              type="button"
              className="border border-gray-300 text-gray-900 text-md rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 flex items-center justify-between bg-white"
              onClick={() => setDropdownOpen((prev) => !prev)}
            >
              <span>
                {selectedCombine
                  ? `${selectedCombine.date} - ${selectedCombine.name} - ${selectedCombine.city}`
                  : "Select an event"}
              </span>
              <FontAwesomeIcon icon={faChevronDown} className="ml-2" />
            </button>
            {dropdownOpen && (
              <div className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 shadow-lg">
                <div className="flex items-center px-2 py-2">
                  <FontAwesomeIcon
                    icon={faSearch}
                    className="text-gray-400 mr-2"
                  />
                  <input
                    type="text"
                    placeholder="Search event name..."
                    className="w-full pl-2 pr-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-400"
                    value={dropdownSearch}
                    onChange={(e) => setDropdownSearch(e.target.value)}
                    autoFocus
                  />
                </div>
                <ul className="max-h-80 overflow-y-auto">
                  {filteredCombines.length === 0 && (
                    <li className="px-4 py-2 text-gray-500">
                      No results found
                    </li>
                  )}
                  {filteredCombines.map((combine) => (
                    <li
                      key={combine.id}
                      className="px-4 py-2 hover:bg-blue-100 cursor-pointer w-full truncate"
                      onClick={() => onCombineChange(combine.id)}
                    >
                      {combine.date} - {combine.name} - {combine.city}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
